export const EXAMPLES_EN = [
    'Generate a bar',
    'Generate a city district',
    'Generate a secret corporate research facility',
    'Generate a high-security bank',
    'Generate an urban bar or nightclub',
    'Generate a dystopian slum region',
    'Generate an illegal cyberware market',
    'Generate a hidden magical library',
    'Generate a futuristic residential complex',
    'Generate an abandoned industrial silo',
    'Generate a gang stronghold',
    'Generate a secret underground bunker',
    'Generate a corporate-controlled city district',
    'Generate a high-tech maximum-security prison',
    'Generate a decaying amusement park',
    'Generate an illegal street racing track',
    'Generate an overcrowded refugee camp',
    'Generate a high-ranking VIP residence',
    'Generate a contaminated radiation zone',
    'Generate a hidden site for black magic rituals',
    'Generate an urban jungle of high-tech office buildings',
    'Generate a high-security data center',
    'Generate a rough harbor area',
    'Generate a futuristic shopping mall',
    'Generate a casino',
    'Generate a city district controlled by organized crime',
    'Generate an abandoned factory',
    'Generate a futuristic hospital complex',
    'Generate a drone combat arena',
    'Generate a cybernetics lab',
    'Generate a big-city jungle',
    'Generate an office building',
    'Generate a corp tower',
    'Generate an extraterritorial corporate enclave',
    'Generate an illegal weapons depot',
    'Generate a smuggler port',
    'Generate a genetic engineering research facility',
    'Generate a Lone Star security checkpoint',
    'Generate a drug park',
    'Generate a noir-style shadowrunner safehouse',
    'Generate a futuristic gangster hideout',
    'Generate a technologically advanced safehouse',
    'Generate an underground fighting arena',
    'Generate a neon-lit nightclub',
    'Generate a secret black market base',
    'Generate a high-tech hacker apartment',
    'Generate a research station hidden in the jungle',
    'Generate a shady embassy lounge',
    'Generate a penthouse',
    'Generate a penthouse apartment in a skyscraper',
    'Generate a squatter settlement',
    'Generate a covert smuggler den',
    'Generate a secret street doc clinic',
    'Generate a dystopian nomad housing settlement',
    'Generate a glamorous elven salon',
    'Generate a ramen shop',
    'Generate a cocktail bar',
    'Generate a beer hall',
    'Generate a pub',
    'Generate a discotheque',
    'Generate a nightclub',
    'Generate a rooftop bar',
    'Generate an urban exploration site',
    'Generate a shadow clinic',
    'Generate an illegal gambling den',
    'Generate a high-tech archive library',
    'Generate a corporation-free drug marketplace',
    'Generate a paranormal museum',
    'Generate a busy airport',
    'Generate a futuristic sports complex',
    'Generate an urban drug lab',
    'Generate an organized crime syndicate HQ',
    'Generate a mysterious sewer system',
    'Generate a cyberpunk Sikh temple',
    'Generate a cutting-edge art gallery',
    'Generate a busy black market',
    'Generate a modern media production facility',
    'Generate a remote ritual site',
    'Generate a futuristic concert hall',
    'Generate a gigantic dystopian corporate campus',
    'Generate a dystopian mass housing complex',
    'Generate an illegal implant clinic',
    'Generate a lively urban market',
    'Generate a technologically enhanced rest stop',
    'Generate an exclusive corporate school',
    'Generate a shady prison colony',
    'Generate a well-equipped runner hideout',
    'Generate a futuristic street race',
    'Generate an inconspicuous shadow bar',
    'Generate a busy weapons smuggler workshop',
    'Generate a dazzling entertainment district',
    'Generate an upscale residential complex',
    'Generate a futuristic technology museum',
    'Generate a paranormal research lab',
    'Generate a shady hacker base',
    'Generate a cybernetic prosthetics shop',
    'Generate a futuristic sushi bar',
    'Generate a well-connected smuggler bar',
]
